"use strict";

import React from "react";

import Details from "vwa/components/Details";
import Pager from "vwa/components/Pager";
import lang from "vwa/lang";

import UserPassword from "./../UserPassword";
import UserContacts from "./../UserContacts";
import UserNotifications from "./../UserNotifications";

export default class UserSettings extends React.Component{
	
	constructor(props){
		super(props);
		this.initState();
	}
	
	initState(){
		this.state = {
			page: "notifications"
		}
	}
	
	render(){
	
		const tabs = [
			{id: "notifications", label: lang.NOTIFICATIONS},
			{id: "contacts", label: lang.CONTACTS},
			{id: "password", label: lang.PASSWORD}
		];
		
		const detailsProps = {
			title: lang.SETTINGS,
			onClose: () => this.props.onClose(),
			tabs: tabs,
			onTabChange: tabId => this.setState({page: tabId}),
			activeTab: this.state.page,
			dragable: false,
		}
		
		return(
			<Details {...detailsProps}>
				<Pager active={this.state.page}>
					<div id="notifications">
						<UserNotifications />
					</div>
					<div id="contacts">
						<UserContacts />
					</div>
					<div id="password">
						<UserPassword />
					</div>
				</Pager>
			</Details>
		);
	}
	
}

UserSettings.propTypes = {
	onClose: React.PropTypes.func
};

UserSettings.defaultProps = {
	onClose: () => {}
};


// WEBPACK FOOTER //
// ./src/view/UserSettings/UserSettings.jsx